import script from "./FeaturedContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedContent.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedContent.vue?vue&type=style&index=0&id=709bfc16&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709bfc16"]])

export default __exports__